import React from 'react';
import styles from './ProgressBarSimple.module.scss';
import { withRouter } from 'react-router-dom';

const ProgressBarSimple = props => {
  const totalItems = props.items.length;

  const { pathname } = props.location;

  const steps = props.items;

  const getActiveStepIndex = () => {
    const matchedStep = steps.find(x => x.url == pathname);
    if (matchedStep) {
      return matchedStep.index;
    } else {
      const otherMatchedStep = steps.find(
        x => x.otherUrls == pathname || x.otherUrls == pathname.substring(1, pathname.length)
      );
      if (otherMatchedStep) {
        return otherMatchedStep.index;
      }
    }

    return 0;
  };

  const activeStepIndex = getActiveStepIndex();

  return (
    <section>
      <div className={`showProgress`}>
        <div className={`${styles.showProgressMobile}`}>
          <div className={`container`}>
            {props.items.map(d =>
              d.index === activeStepIndex ? (
                <div>
                  <span className={styles.stepNumber}>
                    Step {d.index} of {props.items.length}
                  </span>
                  <div className={styles.mobileStepWrap}>
                    {props.items.map(item => (
                      <div
                        className={`${styles.mobileSteps} ${
                          item.index <= activeStepIndex ? styles.finished : ''
                        }`}
                      >
                        {' '}
                        &nbsp;
                      </div>
                    ))}
                  </div>

                  <span className={`${styles.stepTitle}`}>{d.plainLabel}</span>
                </div>
              ) : null
            )}
          </div>
        </div>
        <div className={`container`}>
          <div className={`row`}>
            <div className={`col-12`}>
              <ol className={`${styles.showProgressList}`}>
                {props.items.map(d => (
                  <li
                    key={d.index}
                    className={
                      d.index === activeStepIndex
                        ? styles.active
                        : d.index < activeStepIndex
                        ? styles.completed
                        : ''
                    }
                  >
                    <span className={`${styles.stepTitle}`}>{d.plainLabel}</span>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default withRouter(props => <ProgressBarSimple {...props} />);
